import { ChemistryRow } from "@/pages/chemistries/report/models/ChemistryRow";
import { getChemistryResults } from "@/pages/chemistries/report/repositories/ChemistriesReportRepository";
import { getM1Campaigns } from "@/pages/m1/schedule/repositories/M1CampaignRepository";
import { CampaignResponse } from "@/pages/mill/schedule/models/CampaignReponse";
import { getCampaigns } from "@/pages/mill/schedule/repositories/CampaignRepository";
import { MILL_1 } from "@/setup/mill-config/mill-config";

export const getLastChemistries = async (signal?: AbortSignal) => {
	const chemistries = await getChemistryResults({}, signal);

	return chemistries
		.slice()
		.sort((a, b) => {
			const dateA = a.Reported ? new Date(a.Reported).getTime() : -1;
			const dateB = b.Reported ? new Date(b.Reported).getTime() : -1;
			return dateB - dateA;
		})
		.slice(0, 10) as ChemistryRow[];
};

export const getPendingHeats = async (areaId: number, signal?: AbortSignal) => {
	const start = new Date();
	start.setDate(start.getDate() - 30);

	const fetchCampaigns = areaId === MILL_1.id ? getM1Campaigns : getCampaigns;
	const campaigns = await fetchCampaigns({ start }, signal);

	return campaigns
		.filter((c) => c.HeatId !== null && c.SampleStatusCode !== "P")
		.sort(
			(a, b) => new Date(a.Start).getTime() - new Date(b.Start).getTime(),
		) as CampaignResponse[];
};
